import { Stack } from "expo-router";

/**
 * Opdracht stack layout
 */
export default function OpdrachtLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
